import styled from 'styled-components';
import ArrowTailUpIconSvg from './arrow-tail-up.svg';

const ArrowTailUpIcon = styled(ArrowTailUpIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  fill: ${props => props.fill || '#647a97'};
  
`;

export default ArrowTailUpIcon;

